import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import Breadcrumb from 'components/App/Breadcrumb';
import Meta from 'components/App/Meta';
import Loading from 'components/App/Loading';

import DiscoverCategoryDetails from 'components/DiscoverCategoryDetails';
import styles from './DiscoveryCategoriesDetails.module.scss';

const TITLE = 'Chi tiết danh mục khám phá';

const breadcrumbList = [
  {
    name: 'Danh mục khám phá',
    isActive: false,
    link: '/manager-discovery/category', // TODO: ADD ROUTE WHEN HAVE LINK
  },
  {
    name: TITLE,
    isActive: true,
    link: '',
  },
];

function DiscoveryCategoriesDetails(props) {
  const { id } = useParams();

  const {
    categoryDetailsLoading,
    categoryDetails,
    actionGetDiscoveryCategoryDetails,
    actionCleanupDiscoverCategoryDetails,
  } = props;

  React.useEffect(() => {
    actionGetDiscoveryCategoryDetails(id);

    return () => {
      actionCleanupDiscoverCategoryDetails();
    };
  }, [
    actionCleanupDiscoverCategoryDetails,
    actionGetDiscoveryCategoryDetails,
    id,
  ]);

  return (
    <div className={`page-content ${styles.Page}`}>
      <Meta name={TITLE} />

      <Container fluid>
        <Breadcrumb pageTitle={TITLE} breadcrumbList={breadcrumbList} />

        <Loading loading={categoryDetailsLoading} loaderOnPage />

        {categoryDetails._id && (
          <DiscoverCategoryDetails
            categoryDetails={categoryDetails}
            isCreate={false}
          />
        )}
      </Container>
    </div>
  );
}

DiscoveryCategoriesDetails.propTypes = {
  categoryDetailsLoading: PropTypes.bool.isRequired,
  categoryDetails: PropTypes.instanceOf(Object).isRequired,
  actionCleanupDiscoverCategoryDetails: PropTypes.func.isRequired,
  actionGetDiscoveryCategoryDetails: PropTypes.func.isRequired,
};

export default DiscoveryCategoriesDetails;
